// ============================================================================
// Chart theme constants — validated palette (see analysis-theme.css for the
// CSS-variable mirror). Categorical slots are assigned in FIXED order by
// stable entity id, never by rank in the current result; >8 categories fold
// into "Other". Palette validated with the dataviz six-checks script against
// the light surface #fcfcfb (worst adjacent CVD ΔE 24.2).
// ============================================================================

export const SERIES_COLORS = [
  '#2a78d6', // 1 blue
  '#1baf7a', // 2 aqua
  '#eda100', // 3 yellow
  '#008300', // 4 green
  '#4a3aa7', // 5 violet
  '#e34948', // 6 red
  '#e87ba4', // 7 magenta
  '#eb6834', // 8 orange
];

/** Prior-period / comparison series: recessive gray, never a hue. */
export const PRIOR_SERIES_COLOR = '#898781';

/** Sequential blue ramp (100→700) for magnitude encoding (heatmaps). */
export const SEQ_RAMP = [
  '#cde2fb', '#b7d3f6', '#9ec5f4', '#86b6ef', '#6da7ec', '#5598e7',
  '#3987e5', '#2a78d6', '#256abf', '#1c5cab', '#184f95', '#104281', '#0d366b',
];

/** Snap a 0..1 magnitude onto the sequential ramp. */
export function seqColor(t: number): string {
  const clamped = Math.max(0, Math.min(1, t));
  return SEQ_RAMP[Math.round(clamped * (SEQ_RAMP.length - 1))];
}

/** Reserved status colors — never reused as series colors. */
export const STATUS_COLORS = {
  good: '#0ca30c',
  warning: '#fab219',
  serious: '#ec835a',
  critical: '#d03b3b',
  info: '#898781',
} as const;

export const CHART_INK = {
  primary: '#0b0b0b',
  secondary: '#52514e',
  muted: '#898781',
  grid: '#e1e0d9',
  axis: '#c3c2b7',
  surface: '#fcfcfb',
} as const;

/** Shared recharts axis/grid props so every chart reads the same. */
export const AXIS_PROPS = {
  stroke: CHART_INK.axis,
  tick: { fill: CHART_INK.muted, fontSize: 12 },
  tickLine: false as const,
  axisLine: { stroke: CHART_INK.axis },
};
